import { Lang } from '@/models/Lang'

const locales: Lang[] = [
  {
    id: 'en',
    value: 'en',
    label: '🇺🇸 English',
    flag: '🇺🇸',
  },
  {
    id: 'fr',
    value: 'fr',
    label: '🇫🇷 Français',
    flag: '🇫🇷',
  },
]

const fallbackLanguage = 'en'
const languages = [fallbackLanguage, 'fr']
const cookieName = 'membership_locale'
const defaultNS = 'translation'
const headerName = 'X-Plethore-Membership-Current-Language'

export {
  cookieName,
  defaultNS,
  fallbackLanguage,
  headerName,
  languages,
  locales,
}
